/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Export all models
  Date: April 2020
**/

import commonModel from './common';
import loginModel from './login';
import subHeaderModel from './subHeader';
import orgModel from './organization';
import customizeModel from './customize';
import userListModel from './userList';
import roleModel from './role';
import settingsModel from './settings';
import diagnosisCodesModel from './diagnosisCodes';
import proceduresModel from './procedures';
import reportModel from './report';
import programModel from './programs';
import businessLineModel from './businessLine';
import clientModel from './client';
import importModel from './import';


const storeModel = {
  common: commonModel,
  login: loginModel,
  subHeader: subHeaderModel,
  organization: orgModel,
  customize: customizeModel,
  userList: userListModel,
  roles: roleModel,
  settings: settingsModel,
  diagnosisCodes: diagnosisCodesModel,
  procedures: proceduresModel,
  report: reportModel,
  programs: programModel,
  businessLine: businessLineModel,
  client: clientModel,
  import: importModel,
};

export default storeModel;
